import React from "react"
import { NativeSelect, NativeSelectProps } from "@mantine/core"

const Select: React.VFC<NativeSelectProps> = ({ ...props }) => {
  return <NativeSelect {...props} />
}

export default Select
